/**
 * @desc 通过系统单号获取线下销售单所有信息
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(
  params: API.business.customerOrderFacadeImpl.getAllBySoOrderNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/customerOrder/getAllBySoOrderNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
